import {
  mergeSegments,
  patchShiftLongUnknownSegmentBug,
} from "../utils/segments";
import type {
  TimeRangeFinite,
  Process,
  ProductionSegmentType,
  ProcessGroup,
  ShiftSegment,
  ManyRollupsWithTagsArrays,
  TrendsPageFilterStateType,
  ManyRollupsWithTagsAndRange,
  RollupWithTagsAndCountsAndRange,
  ManyProductionSegmentsArrays,
  AllocationObj,
  LotInfoType,
  DataDumpAggregateType,
  PnlChartSectionType,
  TimeAxisContextStoreType,
  ExpandedTilesDataType,
  CustomerJsonType,
  DataDumpRow,
} from "../types/types";
import { PnlCategoriesEnum, TrendChartBinSizesEnum } from "../types/enums";
import { calcPnlChartCategories } from "../components/Dashboard/PnlSummaryChart/calcPnlChartCategories";
import {
  getTodaysShifts,
  cleanShiftSegments,
  getShiftIndex,
  getToday,
} from "../components/Dashboard/range-selectors/steppable-range-selectors/ShiftSelector/shiftUtils";
import {
  ONE_DAY_OF_MS,
  getFullDayRangeTitle,
  getDayStart,
} from "../utils/timeUtils";
import { uniqBy, isEqual } from "lodash";
import {
  filterObjectByKeepingKeys,
  filterObjectByRemovingKeys,
} from "../utils/arrayUtils";
import {
  ALL_GROUP_NAME_DISPLAY,
  ALL_TAG_NAME_DISPLAY,
  ALL_SHIFT_NAME_DISPLAY,
  createAllProcessGroup,
  ALL_PNL_CATEGORY_NAME_DISPLAY,
} from "../components/FlightTrends/TrendsFilters/filtersDrawerUtils";
import { useCalcPnlChartCategoriesWithProducingLosses } from "../components/Dashboard/PnlSummaryChart/calcPnlChartCategoriesWithProducingLosses";
import { ParsedQuery } from "query-string";
import { CATEGORIES_TO_HIDE_PER_CUSTOMER } from "constants/customers";
import { FormatZonedFn } from "utils/customHooks/genericHooksTypes";
import { makeEmptyRollup } from "../utils/metrics";
import { useGetPageFromPath } from "utils/customHooks/genericHooks";
import { useCallback } from "react";
import { useShouldUseDataDumpsForPnlChart } from "utils/customHooks/whichServerHooks";
import { useSelector } from "store/useSelector";
import * as d3 from "d3";
const SHIFT_FETCH_MAX_RETRIES = 3; // this prevents > MAX subsequent refetches from ShiftsGetter

// if we're within a day (~3 shifts, 5 at most) of the leading edge of shifts, fetch more shifts
const BACKWARD_MIN_DAYS_PADDING = 5;
// since askr only caches 7 days of shifts, wait longer to refetch into the future than into the past
const FORWARD_MIN_DAYS_PADDING = 2;

const UPDATE_SHIFTS = "UPDATE_SHIFTS";
const UPDATE_TODAYS_SHIFTS = "UPDATE_TODAYS_SHIFTS";
const GO_TO_SHIFT = "GO_TO_SHIFT";
const GO_TO_DAY = "GO_TO_DAY";
const CLEAR_ALL_SHIFTS = "CLEAR_ALL_SHIFTS";
const ADD_NEW_SEGMENTS = "ADD_NEW_SEGMENTS";
const ADD_MANY_NEW_SEGMENTS = "ADD_MANY_NEW_SEGMENTS";
const CLEAR_ALL_SEGMENTS = "CLEAR_ALL_SEGMENTS";
const SET_FOCUS_RANGE = "SET_FOCUS_RANGE";
const SET_VISIBLE_RANGE = "SET_VISIBLE_RANGE";
const CLEAR_VISIBLE_PROCESSES = "CLEAR_VISIBLE_PROCESSES";
const CLEAR_ALL_GROUPS_AND_PROCESSES = "CLEAR_ALL_GROUPS_AND_PROCESSES";
const CLEAR_ALL_TREND_CHART_BARS = "CLEAR_ALL_TREND_CHART_BARS";
const CLEAR_ALL_AGGREGATES = "CLEAR_ALL_AGGREGATES";
// const REPLACE_SELECTED_PROCESSES = "REPLACE_SELECTED_PROCESSES";
// const REPLACE_SELECTED_PROCESSES = "REPLACE_SELECTED_PROCESSES";
const UPDATE_ROLLUPS_FOR_PROCESS_CURRENT_TREND_CHART =
  "UPDATE_ROLLUPS_FOR_PROCESS_CURRENT_TREND_CHART";
export const UPDATE_LAST_DATA_DUMP_ROW = "UPDATE_LAST_DATA_DUMP_ROW";
export const UPDATE_LAST_DATA_DUMP_ROW_PER_PROCESS =
  "UPDATE_LAST_DATA_DUMP_ROW_PER_PROCESS";
export const UPDATE_DATA_DUMP_TREND_CHART_FOR_PROCESSES =
  "UPDATE_DATA_DUMP_TREND_CHART_FOR_PROCESSES";
export const UPDATE_DATA_DUMP_TREND_CHART_COUNTS_FOR_PROCESSES =
  "UPDATE_DATA_DUMP_TREND_CHART_COUNTS_FOR_PROCESSES";
export const UPDATE_MANY_DATA_DUMP_TREND_CHART_FOR_PROCESSES =
  "UPDATE_MANY_DATA_DUMP_TREND_CHART_FOR_PROCESSES";
export const UPDATE_MANY_DATA_DUMP_TREND_CHART_COUNTS_FOR_PROCESSES =
  "UPDATE_MANY_DATA_DUMP_TREND_CHART_COUNTS_FOR_PROCESSES";
export const UPDATE_DATA_DUMP_PNL_LOSSES_FOR_PROCESSES =
  "UPDATE_DATA_DUMP_PNL_LOSSES_FOR_PROCESSES";
export const UPDATE_LOT_START_DATA_DUMP_FOR_PROCESSES =
  "UPDATE_LOT_START_DATA_DUMP_FOR_PROCESSES";
export const UPDATE_FULL_RANGE_DATA_DUMP_FOR_PROCESSES =
  "UPDATE_FULL_RANGE_DATA_DUMP_FOR_PROCESSES";
export const UPDATE_FULL_RANGE_DATA_DUMP_FOR_SUBORDINATE_PROCESSES =
  "UPDATE_FULL_RANGE_DATA_DUMP_FOR_SUBORDINATE_PROCESSES";
export const UPDATE_GROUP_TILE_DATA_DUMP_FOR_PROCESSES =
  "UPDATE_GROUP_TILE_DATA_DUMP_FOR_PROCESSES";
export const UPDATE_CUSTOM_DATA_DUMP_FOR_PROCESSES =
  "UPDATE_CUSTOM_DATA_DUMP_FOR_PROCESSES";
export const UPDATE_DATA_DUMP_FOR_PROCESS = "UPDATE_DATA_DUMP_FOR_PROCESS";
export const UPDATE_MANY_DATA_DUMPS_FOR_PROCESSES =
  "UPDATE_MANY_DATA_DUMPS_FOR_PROCESSES";
const UPDATE_ALLOCATION_LIST = "UPDATE_ALLOCATION_LIST";
const UPDATE_HUBLET_VIEW_DATA_DUMP = "UPDATE_HUBLET_VIEW_DATA_DUMP";
const UPDATE_HUBLET_VIEW_DATA_DUMP_ROLLING_WINDOW =
  "UPDATE_HUBLET_VIEW_DATA_DUMP_ROLLING_WINDOW";
const UPDATE_HUBLET_VIEW_CURRENT_RATE = "UPDATE_HUBLET_VIEW_CURRENT_RATE";
const CLEAR_ONE_DATA_DUMP = "CLEAR_ONE_DATA_DUMP";
const CLEAR_ALLOCATION_LIST = "CLEAR_ALLOCATION_LIST";
const UPDATE_ROLLUP_ALL_VISIBLE = "UPDATE_ROLLUP_ALL_VISIBLE";
export const UPDATE_MANY_ROLLUPS_FOR_PROCESSES =
  "UPDATE_MANY_ROLLUPS_FOR_PROCESSES";
const UPDATE_MIDGARD_PROCESS_GROUPS = "UPDATE_MIDGARD_PROCESS_GROUPS";
export const UPDATE_VISIBLE_GROUPS = "UPDATE_VISIBLE_GROUPS";
const UPDATE_TREND_CHART_BIN_SIZE = "UPDATE_TREND_CHART_BIN_SIZE";
const RESET_TRENDS_PAGE_STATE = "RESET_TRENDS_PAGE_STATE";
const UPDATE_TRENDS_PAGE_FILTER_STATE = "UPDATE_TRENDS_PAGE_FILTER_STATE";
const UPDATE_IS_SERIAL_PROCESS = "UPDATE_IS_SERIAL_PROCESS";
const UPDATE_IS_SERIAL_PROCESS_INDICATOR_OPEN =
  "UPDATE_IS_SERIAL_PROCESS_INDICATOR_OPEN";
const UPDATE_IS_WIDE_PROCESS_TILES = "UPDATE_IS_WIDE_PROCESS_TILES";
const HIDE_PNL_CHART_CATEGORIES = "HIDE_PNL_CHART_CATEGORIES";
const SET_SHOULD_FETCH_NEW_SHIFTS = "SET_SHOULD_FETCH_NEW_SHIFTS";
const UPDATE_SELECTED_PROCESSES = "UPDATE_SELECTED_PROCESSES";
const UPDATE_PNL_POPUP_TIME_RANGE = "UPDATE_PNL_POPUP_TIME_RANGE";
const UPDATE_LOT_INFO = "UPDATE_LOT_INFO";
const CLEAR_LOT_INFO = "CLEAR_LOT_INFO";
const UPDATE_LOT_COUNT = "UPDATE_LOT_COUNT";
const CLEAR_LOT_COUNT = "CLEAR_LOT_COUNT";
export const TRENDS_PAGE_FINISH_INITIAL_FILTER =
  "TRENDS_PAGE_FINISH_INITIAL_FILTER";
const UPDATE_IS_FULL_DAY_SELECTED = "UPDATE_IS_FULL_DAY_SELECTED";
const UPDATE_SHOULD_DISPLAY_TIMELINE = "UPDATE_SHOULD_DISPLAY_TIMELINE";
const UPDATE_IS_FILTERS_DRAWER_OPEN = "UPDATE_IS_FILTERS_DRAWER_OPEN";
export const SET_TIMEAXISCONTEXT_STATE = "SET_TIMEAXISCONTEXT_STATE";
const UPDATE_EXPANDED_TILES_DATA = "UPDATE_EXPANDED_TILES_DATA";
const UPDATE_CUSTOMER_JSON = "UPDATE_CUSTOMER_JSON";
const UPDATE_TARGET_RATES_FOR_TREND_BARS = "UPDATE_TARGET_RATES_FOR_TREND_BARS";
const UPDATE_CONSTRAINT_LEADER_PROCESS_IDS =
  "UPDATE_CONSTRAINT_LEADER_PROCESS_IDS";
const UPDATE_MANY_CONSTRAINT_LEADER_PROCESS_IDS =
  "UPDATE_MANY_CONSTRAINT_LEADER_PROCESS_IDS";

export const DATA_DUMP_TYPES = {
  UPDATE_LOT_START_DATA_DUMP_FOR_PROCESSES,
  UPDATE_GROUP_TILE_DATA_DUMP_FOR_PROCESSES,
  UPDATE_DATA_DUMP_FOR_PROCESS,
  UPDATE_FULL_RANGE_DATA_DUMP_FOR_PROCESSES,
  UPDATE_DATA_DUMP_TREND_CHART_FOR_PROCESSES,
  UPDATE_LAST_DATA_DUMP_ROW,
  UPDATE_LAST_DATA_DUMP_ROW_PER_PROCESS,
  UPDATE_DATA_DUMP_PNL_LOSSES_FOR_PROCESSES,
  UPDATE_FULL_RANGE_DATA_DUMP_FOR_SUBORDINATE_PROCESSES,
  UPDATE_CUSTOM_DATA_DUMP_FOR_PROCESSES,
};

/** set any piece of state in the TimeAxisState */
export const setTimeAxisState = (
  nextState: Partial<TimeAxisContextStoreType>
) => ({
  type: SET_TIMEAXISCONTEXT_STATE,
  payload: nextState,
});

export const setShouldFetchNewShifts = (shouldFetchNewShifts: boolean) => ({
  type: SET_SHOULD_FETCH_NEW_SHIFTS,
  payload: shouldFetchNewShifts,
});

export const hidePnlChartCategories = (
  pnlCategoriesArr: PnlCategoriesEnum[]
) => ({
  type: HIDE_PNL_CHART_CATEGORIES,
  payload: pnlCategoriesArr,
});

export const updateIsSerialProcess = (isSerialProcess: boolean) => ({
  type: UPDATE_IS_SERIAL_PROCESS,
  payload: isSerialProcess,
});

export const updateIsSerialProcessIndicatorOpen = (
  isSerialProcessIndicatorOpen: boolean
) => ({
  type: UPDATE_IS_SERIAL_PROCESS_INDICATOR_OPEN,
  payload: isSerialProcessIndicatorOpen,
});

export const updateIsWideProcessTiles = (isWideProcessTiles: boolean) => ({
  type: UPDATE_IS_WIDE_PROCESS_TILES,
  payload: isWideProcessTiles,
});

export const updateExpandedTilesDataForProcess = ({
  processId,
  expandedTilesDataForProcess,
}: {
  processId: string;
  expandedTilesDataForProcess: ExpandedTilesDataType;
}) => ({
  type: UPDATE_EXPANDED_TILES_DATA,
  payload: { processId, expandedTilesDataForProcess },
});

export const updateAllVisibleRollup = (
  allProcessesRollupMetric: RollupWithTagsAndCountsAndRange,
  shouldCalcPnlCharts: boolean
) => ({
  type: UPDATE_ROLLUP_ALL_VISIBLE,
  payload: { allProcessesRollupMetric, shouldCalcPnlCharts },
});

export const clearAllShifts = () => ({
  type: CLEAR_ALL_SHIFTS,
  payload: null,
});
export const updateShifts = ({
  shifts,
  dayStartMsOffset,
  timeZoneMsOffset,
  shouldGoToCurrentShift,
  shouldSetFocusRange = true,
  isFullDaySelected,
  formatZoned,
}: {
  shifts: ShiftSegment[];
  dayStartMsOffset: number;
  timeZoneMsOffset: number;
  shouldGoToCurrentShift: boolean;
  shouldSetFocusRange: boolean;
  isFullDaySelected: boolean;
  // eslint-disable-next-line @typescript-eslint/ban-types
  formatZoned: Function;
}) => ({
  type: UPDATE_SHIFTS,
  payload: {
    shifts,
    dayStartMsOffset,
    timeZoneMsOffset,
    shouldGoToCurrentShift,
    shouldSetFocusRange,
    isFullDaySelected,
    formatZoned,
  },
});
export const goToDay = ({
  newSelectedDay,
  dayStartMsOffset,
  timeZoneMsOffset,
  shouldGoToFirstShiftInDay,
  shouldGoToCurrentShift = false,
  formatZoned,
}: {
  newSelectedDay: ShiftSegment | null;
  dayStartMsOffset: number;
  timeZoneMsOffset: number;
  shouldGoToFirstShiftInDay: boolean;
  shouldGoToCurrentShift?: boolean;
  formatZoned: FormatZonedFn;
}) => ({
  type: GO_TO_DAY,
  payload: {
    newSelectedDay,
    shouldGoToFirstShiftInDay,
    shouldGoToCurrentShift,
    dayStartMsOffset,
    timeZoneMsOffset,
    formatZoned,
  },
});
export const goToShift = (
  newSelectedShift: ShiftSegment,
  dayStartMsOffset: number,
  timeZoneMsOffset: number,
  formatZoned: FormatZonedFn
) => ({
  type: GO_TO_SHIFT,
  payload: {
    newSelectedShift,
    dayStartMsOffset,
    timeZoneMsOffset,
    formatZoned,
  },
});
export const updateTodaysShifts = ({
  selectedDay,
  dayStartMsOffset,
}: {
  selectedDay: TimeRangeFinite;
  dayStartMsOffset: number;
}) => ({
  type: UPDATE_TODAYS_SHIFTS,
  payload: { selectedDay, dayStartMsOffset },
});

export const addNewSegments = (
  id: string,
  segments: ProductionSegmentType[]
) => ({
  type: ADD_NEW_SEGMENTS,
  payload: { id, segments },
});
type ManySegmentsType = {
  processId: string;
  segments: ProductionSegmentType[];
}[];
export const addManyNewSegments = (manySegments: ManySegmentsType) => ({
  type: ADD_MANY_NEW_SEGMENTS,
  payload: manySegments,
});

export const clearAllSegments = () => ({
  type: CLEAR_ALL_SEGMENTS,
  payload: null,
});
export const clearAllTrendChartBars = () => ({
  type: CLEAR_ALL_TREND_CHART_BARS,
  payload: null,
});
export const clearAllAggregates = () => ({
  type: CLEAR_ALL_AGGREGATES,
  payload: null,
});

export const setFocusRange = (focusRange: TimeRangeFinite) => ({
  type: SET_FOCUS_RANGE,
  payload: focusRange,
});

export const setVisibleRange = (visibleRange: TimeRangeFinite) => ({
  type: SET_VISIBLE_RANGE,
  payload: visibleRange,
});

export const clearVisibleProcesses = ({
  groupsToKeep,
  processesToKeep,
}: {
  groupsToKeep: ProcessGroup[];
  processesToKeep: Process[];
}) => ({
  type: CLEAR_VISIBLE_PROCESSES,
  payload: { groupsToKeep, processesToKeep },
});

export const clearAllGroupsAndProcesses = (clearAllGroups: boolean) => ({
  type: CLEAR_ALL_GROUPS_AND_PROCESSES,
  payload: clearAllGroups,
});

export const resetTrendsPageState = () => ({
  type: RESET_TRENDS_PAGE_STATE,
});

export const updateTrendsPageFilterState = ({
  newFilterState,
}: {
  newFilterState: TrendsPageFilterStateType;
}) => ({
  type: UPDATE_TRENDS_PAGE_FILTER_STATE,
  payload: { newFilterState },
});

export const updateTrendChartBinSize = (
  newBinSize: TrendChartBinSizesEnum
) => ({
  type: UPDATE_TREND_CHART_BIN_SIZE,
  payload: newBinSize,
});

export const updateRollupsForProcessTrendChartBars = (
  id: string,
  rollupMetricSingleTrendChartBarArray: RollupWithTagsAndCountsAndRange[]
) => ({
  type: UPDATE_ROLLUPS_FOR_PROCESS_CURRENT_TREND_CHART,
  payload: {
    id,
    rollupMetricSingleTrendChartBarArray,
  },
});

export const updateAllocationList = (allocationList: AllocationObj[]) => ({
  type: UPDATE_ALLOCATION_LIST,
  payload: allocationList,
});

export const updateHubletViewDataDump = (
  dataDumpObj: DataDumpAggregateType
) => ({
  type: UPDATE_HUBLET_VIEW_DATA_DUMP,
  payload: { dataDumpObj },
});
export const updateHubletViewRollingWindowDataDump = (
  dataDumpObj: DataDumpAggregateType
) => ({
  type: UPDATE_HUBLET_VIEW_DATA_DUMP_ROLLING_WINDOW,
  payload: { dataDumpObj },
});
export const updateHubletViewCurrentRatePerMs = (
  currentRate: number | null
) => ({
  type: UPDATE_HUBLET_VIEW_CURRENT_RATE,
  payload: currentRate,
});

export const clearOneDataDumpObj = (
  dataDumpRange: TimeRangeFinite,
  dataDumpProcessIds: string[]
) => ({
  type: CLEAR_ONE_DATA_DUMP,
  payload: { dataDumpRange, dataDumpProcessIds },
});

/** find and remove the passed allocation list from the stored list */
export const clearOneAllocationList = (
  allocationTimeRange: TimeRangeFinite,
  allocationProcessId: string[]
) => ({
  type: CLEAR_ALLOCATION_LIST,
  payload: { allocationTimeRange, allocationProcessId },
});

export const updateSelectedProcesses = (selectedProcessIdsRef: {
  current: string[];
}) => ({
  type: UPDATE_SELECTED_PROCESSES,
  payload: selectedProcessIdsRef,
});
export const updatePnlPopupTimeRange = (
  pnlPopupTimeRange: TimeRangeFinite | null
) => ({
  type: UPDATE_PNL_POPUP_TIME_RANGE,
  payload: pnlPopupTimeRange,
});
export const updateLotInfo = ({
  processId,
  lotInfo,
}: {
  processId: string;
  lotInfo: LotInfoType;
}) => ({
  type: UPDATE_LOT_INFO,
  payload: { processId, lotInfo },
});
export const clearLotInfo = ({ processId }: { processId: string }) => ({
  type: CLEAR_LOT_INFO,
  payload: { processId },
});
export const updateLotCount = ({
  processId,
  lotCount,
}: {
  processId: string;
  lotCount: number;
}) => ({
  type: UPDATE_LOT_COUNT,
  payload: { processId, lotCount },
});
export const clearLotCount = ({ processId }: { processId: string }) => ({
  type: CLEAR_LOT_COUNT,
  payload: { processId },
});

export const updateIsFullDaySelected = (newIsFullDaySelected: boolean) => ({
  type: UPDATE_IS_FULL_DAY_SELECTED,
  payload: newIsFullDaySelected,
});
export const updateShouldDisplayTrendsPageTimeline = (newShould: boolean) => ({
  type: UPDATE_SHOULD_DISPLAY_TIMELINE,
  payload: newShould,
});
export const updateIsFiltersDrawerOpen = (newOpen: boolean) => ({
  type: UPDATE_IS_FILTERS_DRAWER_OPEN,
  payload: newOpen,
});
export const updateCustomerJson = (newCustomerJson: CustomerJsonType) => ({
  type: UPDATE_CUSTOMER_JSON,
  payload: newCustomerJson,
});
export const updateTargetRatesForTrendBars = ({
  processId,
  targetRate,
  trendBarGe,
}: {
  processId: string;
  targetRate: number;
  trendBarGe: number;
}) => ({
  type: UPDATE_TARGET_RATES_FOR_TREND_BARS,
  payload: { processId, targetRate, trendBarGe },
});
export const updateManyConstraintLeaderProcessIds = (
  groupsContraintsData: {
    constraintProcessIds: string[];
    leaderProcessId: string | null;
    groupName: string;
  }[]
) => ({
  type: UPDATE_MANY_CONSTRAINT_LEADER_PROCESS_IDS,
  payload: groupsContraintsData,
});

const now = Date.now();

export const initialTrendsPageFilterState: TrendsPageFilterStateType = {
  group: ALL_GROUP_NAME_DISPLAY,
  process: createAllProcessGroup("").processes[0],
  tag: ALL_TAG_NAME_DISPLAY,
  pnlCategory: ALL_PNL_CATEGORY_NAME_DISPLAY,
  shiftName: ALL_SHIFT_NAME_DISPLAY,
  workScheduleId: "",
};

const EMPTY_AGGREGATES_AND_DATA_DUMPS: Partial<typeof legacyInitialState> = {
  rollupsMetricByProcess: {},
  allRollupsMetricTrendChartBarsArrays: {},
  dataDumpsPnlLossesByUnit: {},
  dataDumpsTrendChart: [],
  dataDumpsTrendChartCounts: [],
  dataDumpFullRange: null,
  dataDumpHubletView: null,
  dataDumpSinceLotStart: null,
  dataDumpsGroupTiles: {},
  dataDumpsFullRangeByProcess: {},
  targetRatesForTrendBars: {},
};

export const defaultTimeAxisContext: TimeAxisContextStoreType = {
  scaleTimeDomain: [0, 1],
  scaleTimeRange: [0, 1],
  xLeft: 100,
  xRight: 0,
  zoomTransform: d3.zoomIdentity,
};

export const legacyInitialState = {
  isAnimationEnabled: true, // for storybook/storyshots, use false in StoreAndSettingsContextProvider to ensure consistent snapshots
  isStorybook: false, // for storybook/storyshots, skip all queries e.g. for page stories
  storyPage: null as string | null, // for storybook/storyshots, use this to fake pages in useGetPageFromPath
  mockNumSlashes: null as number | null, // for storybook/storyshots, use this to fake numSlashes in useGetPageFromPath
  mockLocation: null as { pathname: string; search: string } | null, // for storybook/storyshots, use this to fake the location
  storyQuery: {} as ParsedQuery<string>, // for storybook/storyshots, use this to fake query params for GridLayout's urlQuery
  testData: null as any, // for use in storybook tests
  isFullDaySelected:
    window.localStorage.getItem("isDefaultFullDaySelected") === "true", // 24 hour or shift modes on Timeline page
  /** on single-process pages like Hublet page, contains current count/rate/call states */
  lastDataDumpRow: null as null | DataDumpRow,
  lastDataDumpRowPerProcess: null as null | {
    [processId: string]: DataDumpRow;
  },
  dataDumpsPnlLossesByUnit: {} as {
    [unit: string]: DataDumpAggregateType;
  },
  dataDumpsTrendChart: [] as DataDumpAggregateType[],
  dataDumpsTrendChartCounts: [] as DataDumpAggregateType[],
  dataDumpFullRange: null as null | DataDumpAggregateType,
  dataDumpFullRangeSubordinateProcesses: null as null | DataDumpAggregateType,
  allocationList: [] as AllocationObj[],
  dataDumpHubletView: null as null | DataDumpAggregateType,
  dataDumpHubletViewRollingWindow: null as null | DataDumpAggregateType,
  dataDumpSinceLotStart: null as null | DataDumpAggregateType,
  dataDumpsGroupTiles: {} as {
    [summaryGroup: string]: DataDumpAggregateType;
  },
  dataDumpsFullRangeByProcess: {} as {
    [processId: string]: DataDumpAggregateType;
  },
  dataDumpsFullRangeOverrideMachemetryIds: {} as {
    [processIds: string]: DataDumpAggregateType;
  },
  expandedTilesData: {} as {
    [processId: string]: ExpandedTilesDataType;
  },
  hubletViewCurrentRatePerMs: null as number | null,
  trendsPageFilterState: initialTrendsPageFilterState,
  /** range of data displayed in "focus" region of timeline + summary charts (includes dayStartMsOffset) */
  focusRange: null as TimeRangeFinite | null,
  shouldFetchNewShifts: true,
  shiftFetchRetries: 0,
  visibleRange: null as TimeRangeFinite | null,
  allGroups: [] as ProcessGroup[],
  visibleGroups: [] as ProcessGroup[],
  visibleProcesses: [] as Process[], // = flattened, deduplicated visibleGroups
  selectedProcessIdsRef: { current: [] as string[] }, // list of processes which are included in the aggregates

  // * Single rollup of ALL PROCESSES
  // Single rollup for the focusRange (current shift or current day or custom range)
  // rollupMetric: rollups of all processes together
  allProcessesRollupMetric: makeEmptyRollup(),

  // * Many rollups, ONE PER PROCESS
  // single rollups are used on the details page,
  // or are summed together for a) serial/constraint customers or b) trends page custom filters
  // rollupsMetricByProcess: object of rollups, one for each process
  rollupsMetricByProcess: {} as ManyRollupsWithTagsAndRange,

  // * Segments are displayed on the Timelines
  segments: {} as ManyProductionSegmentsArrays,

  allRollupsMetricTrendChartBarsArrays: {} as ManyRollupsWithTagsArrays,

  // * Pnl chart data
  pnlBreakdownChartCategorySectionsArr: [] as PnlChartSectionType[],
  pnlPopupTimeRange: null as TimeRangeFinite | null,

  // * shifts
  shifts: [] as ShiftSegment[],
  todaysShifts: [] as ShiftSegment[],
  daysWithShifts: [] as ShiftSegment[][],
  /** midnight to midnight; doesn't include dayStartMsOffset */
  selectedDay: {
    // this starts with an approximate value initially and we update it properly in ShiftsGetter
    shift: { name: "" },
    range: { ge: now - ONE_DAY_OF_MS, lt: now },
  } as ShiftSegment,
  selectedShift: {
    shift: { name: "" },
    range: { ge: now - 1, lt: now },
  } as ShiftSegment,

  trendChartBinSize: TrendChartBinSizesEnum.days,

  // flag to set serial/constraint process customizations
  // - filter aggregate charts (butterfly, trend, pnl) down to selected/bottleneck processes only
  // - grey out unselected tiles
  // - grey out unselected timelines
  // - show <IsSerialProcessIndicator> banner
  isSerialProcess: false,
  isSerialProcessIndicatorOpen: false,

  isWideProcessTiles: false,

  // customers may want to hide some of the categories in rollup charts like
  // Pnl chart
  hiddenPnlChartCategories: [] as PnlCategoriesEnum[],
  // later: Trend chart, Butterfly

  // network debugger: count the number of times each state was updated
  timesUpdated: {
    midgardSkuData: 0,
    midgardDataDumpsTrendChartData: 0,
    midgardDataDumpsTrendChartCountsData: 0,
    midgardDataDumpFullRangeData: 0,
    midgardDataDumpHubletViewData: 0,
    midgardLastDataDumpRow: 0,
    midgardLastDataDumpRowPerProcess: 0,
    midgardDataDumpRollingWindowData: 0,
    midgardDataDumpSinceLotStartData: 0,
    midgardDataDumpsGroupTilesData: 0,
    midgardDataDumpsPnlLossesByUnitData: 0,
    midgardDataDumpsFullRangeByProcess: 0,
    midgardDataDumpFullRangeSubordinateProcesses: 0,
    machemetryData: 0,
    askrShiftsData: 0,
    askrSegmentsData: 0,
    askrAggregatesData: 0,
    midgardLotInfo: 0,
    midgardLotCounts: 0,
    supervisorAllocation: 0,
    midgardProcessGroups: 0,
  },

  allLotInfo: {} as { [processId: string]: LotInfoType },
  allLotCounts: {} as { [processId: string]: number },

  // customer json
  customerJson: null as null | CustomerJsonType,

  // trends page: wait until we finish setting the filter state from the url before fetching data
  isTrendsPageFinishedInitialFilter: false,

  // should we display the timeline on the trends page
  shouldDisplayTrendsPageTimeline: true,
  // is the filters drawer open on the trends page
  isFiltersDrawerOpen: false,

  // time axis context
  timeAxisContext: defaultTimeAxisContext,

  // target rate at the start of each trend bar, for single-process pages only
  targetRatesForTrendBars: {} as { [processIdAndBarGe: string]: number },

  constraintProcessIds: {} as { [groupName: string]: string[] },
  leaderProcessId: {} as { [groupName: string]: string | null },
};

export type LegacySliceStateType = typeof legacyInitialState;
export const legacyReducer = (
  state = legacyInitialState,
  action
  // tslint:disable-next-line
): LegacySliceStateType => {
  // tslint:disable-next-line
  switch (action.type) {
    case UPDATE_PNL_POPUP_TIME_RANGE: {
      return { ...state, pnlPopupTimeRange: action.payload };
    }
    case UPDATE_SELECTED_PROCESSES: {
      if (!isEqual(state.selectedProcessIdsRef, action.payload)) {
        return {
          ...state,
          // spread the new state all the way down, so our useSelectedProcesses hook detects a change
          selectedProcessIdsRef: { current: [...action.payload.current] },
        };
      } else {
        return state;
      }
    }
    case SET_SHOULD_FETCH_NEW_SHIFTS: {
      return { ...state, shouldFetchNewShifts: action.payload };
    }
    case HIDE_PNL_CHART_CATEGORIES: {
      return {
        ...state,
        hiddenPnlChartCategories: action.payload,
      };
    }
    case UPDATE_IS_SERIAL_PROCESS: {
      return { ...state, isSerialProcess: action.payload };
    }
    case UPDATE_IS_SERIAL_PROCESS_INDICATOR_OPEN: {
      return { ...state, isSerialProcessIndicatorOpen: action.payload };
    }
    case UPDATE_IS_WIDE_PROCESS_TILES: {
      return { ...state, isWideProcessTiles: action.payload };
    }
    case CLEAR_ALL_SHIFTS: {
      return {
        ...state,
        shifts: [],
      };
    }
    case UPDATE_SHIFTS: {
      const {
        shifts,
        shouldGoToCurrentShift,
        shouldSetFocusRange,
        isFullDaySelected,
        formatZoned,
        dayStartMsOffset,
        timeZoneMsOffset,
      } = action.payload;

      const newShifts = mergeSegments(state.shifts, cleanShiftSegments(shifts));

      const dedupedShifts = uniqBy(
        newShifts,
        shift => shift.range.ge
      ) as ShiftSegment[];
      if (dedupedShifts.length < 1) {
        return state;
      }

      // split shifts into days
      // for displaying in the ShiftSelector

      const [oldestShift, newestShift] = [
        dedupedShifts[0],
        dedupedShifts[dedupedShifts.length - 1],
      ];

      const numDays = Math.ceil(
        (+newestShift.range.ge - +oldestShift.range.ge) / ONE_DAY_OF_MS
      );

      const daysWithShifts = getDaysWithShifts({
        oldestShift,
        numDays,
        dayStartMsOffset,
        timeZoneMsOffset,
        shifts: dedupedShifts,
        formatZoned,
      });
      const now = Date.now();
      const currentShift = dedupedShifts.find(
        shift => shift.range.ge <= now && now < shift.range.lt
      );
      if (!currentShift && shouldGoToCurrentShift) {
        console.log("⚠ current shift not found");
        return state;
      }
      const currentShiftsDayStart = shouldGoToCurrentShift
        ? new Date(currentShift?.range.ge ?? 0).setHours(0, 0, 0, 0)
        : null;

      const newSelectedDay: ShiftSegment = shouldGoToCurrentShift
        ? {
            shift: {
              name: getFullDayRangeTitle(
                currentShiftsDayStart,
                (currentShiftsDayStart ?? 0) + ONE_DAY_OF_MS,
                formatZoned
              ),
            },
            range: {
              ge: currentShiftsDayStart ?? 0,
              lt: (currentShiftsDayStart ?? 0) + ONE_DAY_OF_MS,
            },
          }
        : state.selectedDay;

      const newSelectedShift = isFullDaySelected
        ? {
            ...newSelectedDay,
            range: {
              ge: newSelectedDay.range.ge + dayStartMsOffset,
              lt: newSelectedDay.range.lt + dayStartMsOffset,
            },
          }
        : dedupedShifts[
            getShiftIndex(
              dedupedShifts,
              shouldGoToCurrentShift ? Date.now() : state.selectedShift.range.ge
            )
          ];

      const newFocusRange = newSelectedShift
        ? newSelectedShift.range
        : state.selectedShift.range;
      return {
        ...state,
        shifts: dedupedShifts,
        selectedShift: newSelectedShift || state.selectedShift,
        selectedDay: newSelectedDay,
        ...(shouldSetFocusRange ? { focusRange: newFocusRange } : {}),
        daysWithShifts,
        shouldFetchNewShifts: false,
        // if fetching shifts because we were outside of today, populate today
        ...(!state.todaysShifts ||
        state.todaysShifts.length === 0 ||
        state.shouldFetchNewShifts
          ? {
              todaysShifts: getTodaysShifts({
                dayStartMsOffset,
                timeZoneMsOffset,
                shifts: dedupedShifts,
                selectedDay: newSelectedDay,
                mustReturnAtLeastOne: true, // must show at least one shift today
              }),
            }
          : {}),
        timesUpdated: {
          ...state.timesUpdated,
          askrShiftsData: state.timesUpdated.askrShiftsData + 1,
        },
      };
    }
    case GO_TO_SHIFT: {
      const {
        newSelectedShift,
        dayStartMsOffset,
        timeZoneMsOffset,
        formatZoned,
      } = action.payload;

      if (!newSelectedShift) {
        return state;
      }

      const newSelectedDayStart = getDayStart(
        +newSelectedShift.range.ge,
        dayStartMsOffset,
        timeZoneMsOffset
      );
      const newSelectedDayEnd = newSelectedDayStart + ONE_DAY_OF_MS;

      const newSelectedDay = {
        shift: {
          name: getFullDayRangeTitle(
            newSelectedDayStart,
            newSelectedDayEnd,
            formatZoned
          ),
        },
        range: {
          ge: newSelectedDayStart,
          lt: newSelectedDayEnd,
        },
      };

      const [oldestShift, newestShift] = [
        state.shifts[0],
        state.shifts[state.shifts.length - 1],
      ];

      // if we're close to the edge of or outside
      // of the current shifts we have fetched,
      // fetch more shifts!
      const isShiftNearOldestShift =
        newSelectedShift?.range.ge <
        oldestShift?.range.ge + BACKWARD_MIN_DAYS_PADDING * ONE_DAY_OF_MS;
      const isShiftNearNewestShift =
        newSelectedShift?.range.ge >
        newestShift?.range.ge - FORWARD_MIN_DAYS_PADDING * ONE_DAY_OF_MS;

      // need to fetch if we don't have any
      const haveNoShifts = state.shifts.length === 0;

      const shouldFetchNewShifts = Boolean(
        haveNoShifts || isShiftNearOldestShift || isShiftNearNewestShift
      );

      return {
        ...state,
        // clear all aggregates
        ...EMPTY_AGGREGATES_AND_DATA_DUMPS,
        selectedShift: newSelectedShift,
        focusRange: newSelectedShift?.range || state.focusRange,
        shouldFetchNewShifts,
        // if shift outside of today, go to new day
        ...(!isEqual(newSelectedDay, state.selectedDay)
          ? { selectedDay: newSelectedDay }
          : {}),
      };
    }
    case GO_TO_DAY: {
      const {
        newSelectedDay,
        shouldGoToFirstShiftInDay,
        shouldGoToCurrentShift,
        dayStartMsOffset,
        formatZoned,
        timeZoneMsOffset,
      } = action.payload;

      // if we don't pass in a new day, go to the currently selected day, or today
      const selectedDay =
        newSelectedDay ||
        state.selectedDay ||
        getToday(dayStartMsOffset, timeZoneMsOffset, formatZoned);
      const firstShiftOfDayIndex = getShiftIndex(
        state.shifts,
        selectedDay.range.ge
      );

      const currentShift =
        state.shifts[getShiftIndex(state.shifts, Date.now())];

      const [oldestShift, newestShift] = [
        state.shifts[0],
        state.shifts[Math.max(0, state.shifts.length - 1)],
      ];

      const isDayNearOldestShift =
        !oldestShift ||
        selectedDay.range.ge <
          oldestShift.range.ge + BACKWARD_MIN_DAYS_PADDING * ONE_DAY_OF_MS;
      const isDayNearNewestShift =
        !newestShift ||
        selectedDay.range.ge >
          newestShift.range.ge - FORWARD_MIN_DAYS_PADDING * ONE_DAY_OF_MS;

      const firstShiftOfDayNotFound = firstShiftOfDayIndex === -1;

      const shouldFetchNewShifts =
        // to prevent infinite fetching when we're near the first shift (e.g. Jan 2 2019),
        // use SHIFT_FETCH_MAX_RETRIES to stop refetching, and reset it after it blocks the fetch.
        state.shiftFetchRetries < SHIFT_FETCH_MAX_RETRIES &&
        Boolean(
          firstShiftOfDayNotFound ||
            isDayNearOldestShift ||
            isDayNearNewestShift
        );

      const todaysShifts = shouldFetchNewShifts
        ? []
        : getTodaysShifts({
            dayStartMsOffset,
            timeZoneMsOffset,
            shifts: state.shifts,
            selectedDay,
            mustReturnAtLeastOne: true, // must show at least one shift today
          });

      const willGoToFirstShiftInDay = Boolean(
        shouldGoToFirstShiftInDay &&
          !shouldGoToCurrentShift && // allow shouldGoToCurrentShift to override shouldGoToFirstShiftInDay
          todaysShifts[0]
      );
      const willGoToCurrentShift = Boolean(
        shouldGoToCurrentShift && currentShift
      );

      return {
        ...state,
        // clear all aggregates
        ...EMPTY_AGGREGATES_AND_DATA_DUMPS,
        // count the number of subsequent fetches and cap at SHIFT_FETCH_MAX_RETRIES
        // reset whenever we succeed
        shiftFetchRetries: shouldFetchNewShifts
          ? state.shiftFetchRetries + 1
          : 0,
        todaysShifts,
        selectedDay,
        shouldFetchNewShifts,
        ...(willGoToFirstShiftInDay
          ? // go to first shift in day
            {
              selectedShift: todaysShifts[0],
              focusRange: todaysShifts[0].range,
            }
          : willGoToCurrentShift
            ? // go to current shift
              {
                selectedShift: currentShift,
                focusRange: currentShift.range,
              }
            : // go to full day
              {
                focusRange: {
                  ge:
                    selectedDay.range.ge + dayStartMsOffset + timeZoneMsOffset,
                  lt:
                    selectedDay.range.lt + dayStartMsOffset + timeZoneMsOffset,
                },
              }),
      };
    }
    case ADD_NEW_SEGMENTS: {
      const oldSegments = state.segments[action.payload.id] || [];
      const newSegments = action.payload.segments.filter(s =>
        s.pnl && s.pnl.category ? true : console.error()
      );
      const segments = mergeSegments(oldSegments, newSegments);

      // add the the boolean isSameCategoryAsPrevSegment to segment
      let prevCategory = "";

      const segmentsWithIsSameCategory = segments.map(segment => {
        // detect if it's the same
        const isSameCategoryAsPrevSegment =
          prevCategory === segment.pnl.category;

        // store this one to compare to the next
        prevCategory = segment.pnl.category;

        return {
          ...segment,
          isSameCategoryAsPrevSegment,
        };
      });
      return {
        ...state,
        segments: {
          ...state.segments,
          [action.payload.id]: segmentsWithIsSameCategory,
        },
        timesUpdated: {
          ...state.timesUpdated,
          askrSegmentsData: state.timesUpdated.askrSegmentsData + 1,
        },
      };
    }
    case ADD_MANY_NEW_SEGMENTS: {
      const manySegments: ManySegmentsType = action.payload;

      const manySegmentsProcessed: ManySegmentsType = manySegments.map(
        ({ processId, segments }) => {
          const oldSegments = state.segments[processId] || [];
          const newSegments = segments.filter(s =>
            s.pnl && s.pnl.category ? true : console.error()
          );
          const mergedSegments = mergeSegments(oldSegments, newSegments);
          const patchedSegments = patchShiftLongUnknownSegmentBug(
            mergedSegments,
            state.todaysShifts
          );

          // add the the boolean isSameCategoryAsPrevSegment to segment
          let prevCategory = "";

          const segmentsWithIsSameCategory = patchedSegments.map(segment => {
            // detect if it's the same
            const isSameCategoryAsPrevSegment =
              prevCategory === segment.pnl.category;

            // store this one to compare to the next
            prevCategory = segment.pnl.category;

            return {
              ...segment,
              isSameCategoryAsPrevSegment,
            };
          });

          return { processId, segments: segmentsWithIsSameCategory };
        }
      );

      return {
        ...state,
        segments: {
          ...state.segments,
          ...manySegmentsProcessed.reduce((acc, { processId, segments }) => {
            const updatedSegments = uniqBy(
              // only the first occurrence of each element is kept https://lodash.com/docs/4.17.15#uniq
              // so, put the new segments at the front of the array

              [
                ...segments,
                ...(state.segments[processId]
                  // * exception: when sticky tag is reapplied, remove the latest segment (e.g. producing) with !lt, since older tag which also has !lt will now override it
                  ?.filter(s => s.range.lt) ?? []),
              ],
              s => s.range.ge
            ).sort((a, b) => (a.range.ge ?? 0) - (b.range.ge ?? 0));

            return {
              ...acc,
              [processId]: updatedSegments,
            };
          }, {}),
        },
        timesUpdated: {
          ...state.timesUpdated,
          askrSegmentsData: state.timesUpdated.askrSegmentsData + 1,
        },
      };
    }
    case CLEAR_ALL_SEGMENTS: {
      return {
        ...state,
        segments: {},
        dataDumpsTrendChart: [],
        dataDumpsTrendChartCounts: [],
      };
    }
    case CLEAR_ALL_TREND_CHART_BARS: {
      return {
        ...state,
        allRollupsMetricTrendChartBarsArrays: {} as ManyRollupsWithTagsArrays,
        dataDumpsTrendChart: [],
        dataDumpsTrendChartCounts: [],
      };
    }
    case CLEAR_ALL_AGGREGATES: {
      return {
        ...state,
        ...EMPTY_AGGREGATES_AND_DATA_DUMPS,
      };
    }
    case SET_FOCUS_RANGE: {
      return {
        ...state,
        focusRange: { ge: +action.payload.ge, lt: +action.payload.lt },
        // clear all aggregates/counts when focus range changes
        ...EMPTY_AGGREGATES_AND_DATA_DUMPS,
      };
    }
    case SET_VISIBLE_RANGE: {
      return {
        ...state,
        visibleRange: { ge: +action.payload.ge, lt: +action.payload.lt },
      };
    }
    case CLEAR_VISIBLE_PROCESSES: {
      const { groupsToKeep, processesToKeep } = action.payload; // default = []

      const processIdsToKeep =
        processesToKeep && processesToKeep.map(p => p.id);

      const filterObjectByProcessIds = object =>
        filterObjectByKeepingKeys(object, processIdsToKeep);

      const rollupsToKeep = {
        rollupsMetricByProcess: filterObjectByProcessIds(
          state.rollupsMetricByProcess
        ) as ManyRollupsWithTagsAndRange,
      };

      return {
        ...state,
        visibleProcesses: processesToKeep,
        visibleGroups: groupsToKeep,
        ...rollupsToKeep,
      };
    }
    case CLEAR_ALL_GROUPS_AND_PROCESSES: {
      return {
        ...state,
        visibleGroups: [],
        visibleProcesses: [],
        ...(action.payload ? { allGroups: [] } : {}),
      };
    }
    case UPDATE_MIDGARD_PROCESS_GROUPS: {
      const { processGroups } = action.payload;
      return {
        ...state,
        allGroups: uniqBy(
          [...state.allGroups, ...processGroups],
          "summaryGroup"
        ),
        timesUpdated: {
          ...state.timesUpdated,
          midgardProcessGroups: state.timesUpdated.midgardProcessGroups + 1,
        },
      };
    }
    case UPDATE_VISIBLE_GROUPS: {
      return {
        ...state,
        visibleGroups: action.payload,
      };
    }
    case UPDATE_MANY_ROLLUPS_FOR_PROCESSES: {
      const rollups = action.payload;

      return {
        ...state,
        rollupsMetricByProcess: {
          ...state.rollupsMetricByProcess,
          ...rollups,
        },
        timesUpdated: {
          ...state.timesUpdated,
          askrAggregatesData: state.timesUpdated.askrAggregatesData + 1,
        },
      };
    }
    case UPDATE_ROLLUPS_FOR_PROCESS_CURRENT_TREND_CHART: {
      const { id, rollupMetricSingleTrendChartBarArray } = action.payload;

      return {
        ...state,
        allRollupsMetricTrendChartBarsArrays: {
          ...state.allRollupsMetricTrendChartBarsArrays,
          [id]: rollupMetricSingleTrendChartBarArray,
        },
        timesUpdated: {
          ...state.timesUpdated,
          askrAggregatesData: state.timesUpdated.askrAggregatesData + 1,
        },
      };
    }
    case CLEAR_ONE_DATA_DUMP: {
      const { dataDumpRange, dataDumpProcessIds } = action.payload;
      return {
        ...state,
        dataDumpsTrendChart: [
          ...state.dataDumpsTrendChart.filter(
            // filter out the data dump with the matching time range GE & process ids
            ({ range, processIds }) =>
              !(
                isEqual(
                  // match the ge only since the lt of the current bar changes frequently
                  range.ge,
                  dataDumpRange.ge
                ) && isEqual(processIds, dataDumpProcessIds)
              )
          ),
        ],
        dataDumpsTrendChartCounts: [
          ...state.dataDumpsTrendChartCounts.filter(
            ({ range, processIds }) =>
              !(
                isEqual(
                  // match the ge only since the lt of the current bar changes frequently
                  range.ge,
                  dataDumpRange.ge
                ) && isEqual(processIds, dataDumpProcessIds)
              )
          ),
        ],
      };
    }
    case CLEAR_ALLOCATION_LIST: {
      const { allocationTimeRange, allocationProcessIds } = action.payload;
      return {
        ...state,
        allocationList: [
          ...state.allocationList.filter(
            // filter down allocation list to remove entries with matching timerange and process id
            ({ range, processId }) =>
              !(
                isEqual(range.ge, allocationTimeRange.ge) &&
                isEqual(range.lt, allocationTimeRange.lt) &&
                isEqual([processId], allocationProcessIds)
              )
          ),
        ],
      };
    }
    case UPDATE_ALLOCATION_LIST: {
      const allocationList: AllocationObj[] = action.payload;

      return {
        ...state,
        allocationList,
        timesUpdated: {
          ...state.timesUpdated,
          supervisorAllocation: state.timesUpdated.supervisorAllocation + 1,
        },
      };
    }
    case UPDATE_LAST_DATA_DUMP_ROW: {
      const lastDataDumpRow = action.payload;
      return {
        ...state,
        lastDataDumpRow,
        timesUpdated: {
          ...state.timesUpdated,
          midgardLastDataDumpRow: state.timesUpdated.midgardLastDataDumpRow + 1,
        },
      };
    }
    case UPDATE_LAST_DATA_DUMP_ROW_PER_PROCESS: {
      const lastDataDumpRowPerProcess = action.payload;
      return {
        ...state,
        lastDataDumpRowPerProcess,
        timesUpdated: {
          ...state.timesUpdated,
          midgardLastDataDumpRowPerProcess:
            state.timesUpdated.midgardLastDataDumpRowPerProcess + 1,
        },
      };
    }
    case UPDATE_DATA_DUMP_TREND_CHART_FOR_PROCESSES: {
      const dataDumpObj: DataDumpAggregateType = {
        ...action.payload.dataDumpObj,
        range: {
          ge: Number(action.payload.dataDumpObj.range.ge),
          lt: Number(action.payload.dataDumpObj.range.lt),
        },
      };

      // new dataDump object goes at the front, so old ones are replaced
      // lodash uniq "only the first occurrence of each element is kept" https://lodash.com/docs/#uniq
      const newDataDumps = uniqBy(
        [dataDumpObj, ...state.dataDumpsTrendChart],
        // filter out any duplicates (we only use ge since lt of the current bar can change)
        ({ range, processIds }) => `${range.ge}${JSON.stringify(processIds)}`
      );

      // if we already have a data dump for these process ids, replace it
      // otherwise, prepend it to the list
      // (data dumps gets cleared when focus range changes)
      return {
        ...state,
        dataDumpsTrendChart: newDataDumps,
        timesUpdated: {
          ...state.timesUpdated,
          midgardDataDumpsTrendChartData:
            state.timesUpdated.midgardDataDumpsTrendChartData + 1,
        },
      };
    }
    case UPDATE_DATA_DUMP_TREND_CHART_COUNTS_FOR_PROCESSES: {
      const dataDumpObj: DataDumpAggregateType = {
        ...action.payload.dataDumpObj,
        range: {
          ge: Number(action.payload.dataDumpObj.range.ge),
          lt: Number(action.payload.dataDumpObj.range.lt),
        },
      };

      // new dataDump object goes at the front, so old ones are replaced
      // lodash uniq "only the first occurrence of each element is kept" https://lodash.com/docs/#uniq
      const newDataDumps = uniqBy(
        [dataDumpObj, ...state.dataDumpsTrendChartCounts],
        // filter out any duplicates (we only use ge since lt of the current bar can change)
        ({ range, processIds }) => `${range.ge}${JSON.stringify(processIds)}`
      );

      // if we already have a data dump for these process ids, replace it
      // otherwise, prepend it to the list
      // (data dumps gets cleared when focus range changes)
      return {
        ...state,
        dataDumpsTrendChartCounts: newDataDumps,
        timesUpdated: {
          ...state.timesUpdated,
          midgardDataDumpsTrendChartCountsData:
            state.timesUpdated.midgardDataDumpsTrendChartCountsData + 1,
        },
      };
    }
    case UPDATE_MANY_DATA_DUMP_TREND_CHART_FOR_PROCESSES: {
      const dataDumpObjs: DataDumpAggregateType[] = action.payload;

      // new dataDump object goes at the front, so old ones are replaced
      // lodash uniq "only the first occurrence of each element is kept" https://lodash.com/docs/#uniq
      const newDataDumps = uniqBy(
        [...dataDumpObjs, ...state.dataDumpsTrendChart],
        // filter out any duplicates (we only use ge since lt of the current bar can change)
        ({ range, processIds }) => `${range.ge}${JSON.stringify(processIds)}`
      );

      // if we already have a data dump for these process ids, replace it
      // otherwise, prepend it to the list
      // (data dumps gets cleared when focus range changes)
      return {
        ...state,
        dataDumpsTrendChart: newDataDumps,
        timesUpdated: {
          ...state.timesUpdated,
          midgardDataDumpsTrendChartData:
            state.timesUpdated.midgardDataDumpsTrendChartData + 1,
        },
      };
    }
    case UPDATE_MANY_DATA_DUMP_TREND_CHART_COUNTS_FOR_PROCESSES: {
      const dataDumpObjs: DataDumpAggregateType[] = action.payload;

      // new dataDump object goes at the front, so old ones are replaced
      // lodash uniq "only the first occurrence of each element is kept" https://lodash.com/docs/#uniq
      const newDataDumps = uniqBy(
        [...dataDumpObjs, ...state.dataDumpsTrendChartCounts],
        // filter out any duplicates (we only use ge since lt of the current bar can change)
        ({ range, processIds }) => `${range.ge}${JSON.stringify(processIds)}`
      );

      // if we already have a data dump for these process ids, replace it
      // otherwise, prepend it to the list
      // (data dumps gets cleared when focus range changes)
      return {
        ...state,
        dataDumpsTrendChartCounts: newDataDumps,
        timesUpdated: {
          ...state.timesUpdated,
          midgardDataDumpsTrendChartCountsData:
            state.timesUpdated.midgardDataDumpsTrendChartCountsData + 1,
        },
      };
    }
    case UPDATE_DATA_DUMP_PNL_LOSSES_FOR_PROCESSES: {
      // for each unit (e.g. cups, bottles),
      const { unit } = action.payload;

      // store a dataDump for all machines producing that unit
      const dataDumpObj: DataDumpAggregateType = {
        ...action.payload.dataDumpObj,
        range: {
          ge: Number(action.payload.dataDumpObj.range.ge),
          lt: Number(action.payload.dataDumpObj.range.lt),
        },
      };

      // if we already have a data dump for this unit, replace it
      return {
        ...state,
        dataDumpsPnlLossesByUnit: {
          ...state.dataDumpsPnlLossesByUnit,
          [unit]: dataDumpObj,
        },
        timesUpdated: {
          ...state.timesUpdated,
          midgardDataDumpsPnlLossesByUnitData:
            state.timesUpdated.midgardDataDumpsPnlLossesByUnitData + 1,
        },
      };
    }
    case UPDATE_FULL_RANGE_DATA_DUMP_FOR_PROCESSES: {
      const dataDumpObj: DataDumpAggregateType = {
        ...action.payload.dataDumpObj,
        range: {
          ge: Number(action.payload.dataDumpObj.range.ge),
          lt: Number(action.payload.dataDumpObj.range.lt),
        },
      };
      return {
        ...state,
        dataDumpFullRange: dataDumpObj,
        timesUpdated: {
          ...state.timesUpdated,
          midgardDataDumpFullRangeData:
            state.timesUpdated.midgardDataDumpFullRangeData + 1,
        },
      };
    }
    case UPDATE_FULL_RANGE_DATA_DUMP_FOR_SUBORDINATE_PROCESSES: {
      const dataDumpObj: DataDumpAggregateType = {
        ...action.payload.dataDumpObj,
        range: {
          ge: Number(action.payload.dataDumpObj.range.ge),
          lt: Number(action.payload.dataDumpObj.range.lt),
        },
      };
      return {
        ...state,
        dataDumpFullRangeSubordinateProcesses: dataDumpObj,
        timesUpdated: {
          ...state.timesUpdated,
          midgardDataDumpFullRangeSubordinateProcesses:
            state.timesUpdated.midgardDataDumpFullRangeSubordinateProcesses + 1,
        },
      };
    }
    case UPDATE_CUSTOM_DATA_DUMP_FOR_PROCESSES: {
      const dataDumpObj: DataDumpAggregateType = {
        ...action.payload.dataDumpObj,
        range: {
          ge: Number(action.payload.dataDumpObj.range.ge),
          lt: Number(action.payload.dataDumpObj.range.lt),
        },
      };
      return {
        ...state,
        dataDumpsFullRangeOverrideMachemetryIds: {
          ...state.dataDumpsFullRangeOverrideMachemetryIds,
          [action.payload.overrideMachemetryIds]: dataDumpObj,
        },
      };
    }
    case UPDATE_GROUP_TILE_DATA_DUMP_FOR_PROCESSES: {
      const dataDumpObj: DataDumpAggregateType = {
        ...action.payload.dataDumpObj,
        range: {
          ge: Number(action.payload.dataDumpObj.range.ge),
          lt: Number(action.payload.dataDumpObj.range.lt),
        },
      };
      return {
        ...state,
        dataDumpsGroupTiles: {
          ...state.dataDumpsGroupTiles,
          [action.payload.summaryGroup]: dataDumpObj,
        },
        timesUpdated: {
          ...state.timesUpdated,
          midgardDataDumpsGroupTilesData:
            state.timesUpdated.midgardDataDumpsGroupTilesData + 1,
        },
      };
    }
    case UPDATE_DATA_DUMP_FOR_PROCESS: {
      const dataDumpObj: DataDumpAggregateType = {
        ...action.payload.dataDumpObj,
        range: {
          ge: Number(action.payload.dataDumpObj.range.ge),
          lt: Number(action.payload.dataDumpObj.range.lt),
        },
      };
      return {
        ...state,
        dataDumpsFullRangeByProcess: {
          ...state.dataDumpsFullRangeByProcess,
          [action.payload.processId]: dataDumpObj,
        },
        timesUpdated: {
          ...state.timesUpdated,
          midgardDataDumpsFullRangeByProcess:
            state.timesUpdated.midgardDataDumpsFullRangeByProcess + 1,
        },
      };
    }
    case UPDATE_MANY_DATA_DUMPS_FOR_PROCESSES: {
      const newDataDumpsObj = action.payload as {
        [processId: string]: DataDumpAggregateType;
      };

      const dataDumpsFullRangeByProcess = {
        ...state.dataDumpsFullRangeByProcess,
        ...newDataDumpsObj,
      };
      return {
        ...state,
        dataDumpsFullRangeByProcess,
        timesUpdated: {
          ...state.timesUpdated,
          midgardDataDumpsFullRangeByProcess:
            state.timesUpdated.midgardDataDumpsFullRangeByProcess + 1,
        },
      };
    }
    case UPDATE_LOT_START_DATA_DUMP_FOR_PROCESSES: {
      const dataDumpObj: DataDumpAggregateType = {
        ...action.payload.dataDumpObj,
        range: {
          ge: Number(action.payload.dataDumpObj.range.ge),
          lt: Number(action.payload.dataDumpObj.range.lt),
        },
      };
      return {
        ...state,
        dataDumpSinceLotStart: dataDumpObj,
        timesUpdated: {
          ...state.timesUpdated,
          midgardDataDumpSinceLotStartData:
            state.timesUpdated.midgardDataDumpSinceLotStartData + 1,
        },
      };
    }
    case UPDATE_HUBLET_VIEW_DATA_DUMP: {
      const dataDumpObj: DataDumpAggregateType = action.payload.dataDumpObj;
      return {
        ...state,
        dataDumpHubletView: dataDumpObj,
        timesUpdated: {
          ...state.timesUpdated,
          midgardDataDumpHubletViewData:
            state.timesUpdated.midgardDataDumpHubletViewData + 1,
        },
      };
    }
    case UPDATE_HUBLET_VIEW_DATA_DUMP_ROLLING_WINDOW: {
      const dataDumpObj: DataDumpAggregateType = action.payload.dataDumpObj;
      return {
        ...state,
        dataDumpHubletViewRollingWindow: dataDumpObj,
        timesUpdated: {
          ...state.timesUpdated,
          midgardDataDumpRollingWindowData:
            state.timesUpdated.midgardDataDumpRollingWindowData + 1,
        },
      };
    }
    case UPDATE_HUBLET_VIEW_CURRENT_RATE: {
      return {
        ...state,
        hubletViewCurrentRatePerMs: action.payload,
      };
    }
    case UPDATE_ROLLUP_ALL_VISIBLE: {
      const { allProcessesRollupMetric, shouldCalcPnlCharts } = action.payload;
      return {
        ...state,
        allProcessesRollupMetric,
        ...(shouldCalcPnlCharts
          ? {
              pnlBreakdownChartCategorySectionsArr: calcPnlChartCategories(
                allProcessesRollupMetric,
                state.hiddenPnlChartCategories
              ),
            }
          : {}),
      };
    }
    case UPDATE_EXPANDED_TILES_DATA: {
      const { processId, expandedTilesDataForProcess } = action.payload;
      return {
        ...state,
        expandedTilesData: {
          ...state.expandedTilesData,
          [processId]: expandedTilesDataForProcess,
        },
        timesUpdated: {
          ...state.timesUpdated,
          midgardSkuData: state.timesUpdated.midgardSkuData + 1,
        },
      };
    }
    case RESET_TRENDS_PAGE_STATE: {
      return {
        ...state,
        trendsPageFilterState: initialTrendsPageFilterState,
        trendChartBinSize: TrendChartBinSizesEnum.weeks,
        isTrendsPageFinishedInitialFilter:
          legacyInitialState.isTrendsPageFinishedInitialFilter,
      };
    }
    case UPDATE_TRENDS_PAGE_FILTER_STATE: {
      const { newFilterState } = action.payload;
      return {
        ...state,
        trendsPageFilterState: newFilterState,
      };
    }
    case UPDATE_TREND_CHART_BIN_SIZE: {
      const newBinSize = action.payload;
      return {
        ...state,
        trendChartBinSize: newBinSize,
        // clear the trend chart bars
        allRollupsMetricTrendChartBarsArrays: {},
        dataDumpsTrendChart: [],
        dataDumpsTrendChartCounts: [],
      };
    }

    case UPDATE_LOT_INFO: {
      const { processId, lotInfo } = action.payload;
      return {
        ...state,
        allLotInfo: { ...state.allLotInfo, [processId]: lotInfo },
        timesUpdated: {
          ...state.timesUpdated,
          midgardLotInfo: state.timesUpdated.midgardLotInfo + 1,
        },
      };
    }
    case CLEAR_LOT_INFO: {
      const { processId } = action.payload;
      return {
        ...state,
        allLotInfo: {
          ...filterObjectByRemovingKeys(state.allLotInfo, [processId]),
        } as { [processId: string]: LotInfoType },
      };
    }

    case UPDATE_LOT_COUNT: {
      const { processId, lotCount } = action.payload;
      return {
        ...state,
        allLotCounts: { ...state.allLotCounts, [processId]: lotCount },
        timesUpdated: {
          ...state.timesUpdated,
          midgardLotCounts: state.timesUpdated.midgardLotCounts + 1,
        },
      };
    }
    case CLEAR_LOT_COUNT: {
      const { processId } = action.payload;
      return {
        ...state,
        allLotCounts: {
          ...filterObjectByRemovingKeys(state.allLotCounts, [processId]),
        } as { [processId: string]: number },
      };
    }
    case TRENDS_PAGE_FINISH_INITIAL_FILTER: {
      return {
        ...state,
        isTrendsPageFinishedInitialFilter: true,
      };
    }
    case UPDATE_IS_FULL_DAY_SELECTED: {
      return {
        ...state,
        isFullDaySelected: action.payload,
      };
    }
    case UPDATE_SHOULD_DISPLAY_TIMELINE: {
      return {
        ...state,
        shouldDisplayTrendsPageTimeline: action.payload,
      };
    }
    case UPDATE_IS_FILTERS_DRAWER_OPEN: {
      return {
        ...state,
        isFiltersDrawerOpen: action.payload,
      };
    }
    case UPDATE_CUSTOMER_JSON: {
      return {
        ...state,
        customerJson: action.payload,
      };
    }
    case UPDATE_TARGET_RATES_FOR_TREND_BARS: {
      const { processId, targetRate, trendBarGe } = action.payload;

      return {
        ...state,
        targetRatesForTrendBars: {
          ...state.targetRatesForTrendBars,
          [`${processId}-${trendBarGe}`]: targetRate,
        },
      };
    }
    case UPDATE_CONSTRAINT_LEADER_PROCESS_IDS: {
      const { groupName, constraintProcessIds, leaderProcessId } =
        action.payload;

      return {
        ...state,
        constraintProcessIds: {
          ...state.constraintProcessIds,
          [groupName]: constraintProcessIds,
        },
        leaderProcessId: {
          ...state.leaderProcessId,
          [groupName]: leaderProcessId,
        },
      };
    }
    case UPDATE_MANY_CONSTRAINT_LEADER_PROCESS_IDS: {
      const groupsConstraintsData = action.payload;
      if (groupsConstraintsData.length === 0) {
        return state;
      }
      const constraintProcessIds = {
        ...state.constraintProcessIds,
        ...groupsConstraintsData.reduce(
          (acc, { groupName, constraintProcessIds }) => ({
            ...acc,
            [groupName]: constraintProcessIds,
          }),
          {}
        ),
      };

      const leaderProcessId = {
        ...state.leaderProcessId,
        ...groupsConstraintsData.reduce(
          (acc, { groupName, leaderProcessId }) => ({
            ...acc,
            [groupName]: leaderProcessId,
          }),
          {}
        ),
      };

      return {
        ...state,
        constraintProcessIds,
        leaderProcessId,
      };
    }
    case SET_TIMEAXISCONTEXT_STATE: {
      const timeAxisContext = { ...state.timeAxisContext, ...action.payload };
      return {
        ...state,
        timeAxisContext,
      };
    }

    default: {
      return state;
    }
  }
};

type getDaysWithShiftsType = {
  oldestShift: any;
  numDays: number;
  dayStartMsOffset: any;
  timeZoneMsOffset: number;
  shifts: any;
  formatZoned: FormatZonedFn;
};

export function getDoesCustomerShowProducing(ckey: string) {
  return !CATEGORIES_TO_HIDE_PER_CUSTOMER[ckey]?.includes("producing");
}

export function useGetPnlChartForCustomer() {
  const calcPnlChartCategoriesWithProducingLosses =
    useCalcPnlChartCategoriesWithProducingLosses();
  const shouldUsePnlLossesData = useShouldUseDataDumpsForPnlChart();
  const hiddenPnlChartCategories = useSelector(
    state => state.legacy.hiddenPnlChartCategories
  );
  const { isTrendsPage } = useGetPageFromPath();

  return useCallback(
    (
      dataDump: DataDumpAggregateType | null,
      rollupMetric: RollupWithTagsAndCountsAndRange
    ) =>
      shouldUsePnlLossesData
        ? (dataDump && calcPnlChartCategoriesWithProducingLosses(dataDump)) ||
          []
        : calcPnlChartCategories(
            rollupMetric,
            isTrendsPage ? [] : hiddenPnlChartCategories
          ),
    [
      calcPnlChartCategoriesWithProducingLosses,
      hiddenPnlChartCategories,
      isTrendsPage,
      shouldUsePnlLossesData,
    ]
  );
}

export function getDaysWithShifts({
  oldestShift,
  numDays,
  dayStartMsOffset,
  timeZoneMsOffset,
  shifts,
  formatZoned,
}: getDaysWithShiftsType): ShiftSegment[][] {
  const daysWithShifts = [] as ShiftSegment[][]; // (some days have no shifts — we don't include these)
  const firstDayStart = getDayStart(
    +oldestShift.range.ge,
    dayStartMsOffset,
    timeZoneMsOffset
  );
  const daysSkippedOverall = 0; // skip days with no shifts

  const MAX_SKIPPED_DAYS = 50;
  [...Array(numDays)].forEach((_, dayIdx) => {
    let daysSkippedCurrent = 0; // skip days with no shifts
    if (daysSkippedOverall >= MAX_SKIPPED_DAYS) {
      return;
    }
    const timeBeforeToday = (dayIdx + daysSkippedOverall) * ONE_DAY_OF_MS;

    // populate shifts forwards from the oldest shift
    const nextGe = firstDayStart + timeBeforeToday;
    const nextLt = firstDayStart + timeBeforeToday + ONE_DAY_OF_MS;
    const thisDay: ShiftSegment = {
      shift: { name: getFullDayRangeTitle(nextGe, nextLt, formatZoned) },
      range: {
        ge: nextGe,
        lt: nextLt,
      },
    };

    let newTodaysShifts = getTodaysShifts({
      dayStartMsOffset,
      timeZoneMsOffset,
      shifts,
      selectedDay: thisDay,
      mustReturnAtLeastOne: false, // since we skip days with no shifts
    });

    // for each shift-free day,
    while (
      newTodaysShifts.length === 0 &&
      daysSkippedCurrent < MAX_SKIPPED_DAYS
    ) {
      daysSkippedCurrent += 1;
      // get the next day's shifts instead
      newTodaysShifts = getTodaysShifts({
        dayStartMsOffset,
        timeZoneMsOffset,
        shifts,
        selectedDay: {
          shift: {},
          range: {
            ge:
              thisDay.range.ge +
              timeBeforeToday +
              daysSkippedCurrent * ONE_DAY_OF_MS,
            lt:
              thisDay.range.lt +
              timeBeforeToday +
              daysSkippedCurrent * ONE_DAY_OF_MS,
          },
        },
        mustReturnAtLeastOne: false,
      });
    }
    if (newTodaysShifts.length > 0) {
      daysWithShifts.push(newTodaysShifts);
    }
  });
  return uniqBy(
    daysWithShifts.sort((day1, day2) => +day1[0].range.ge - +day2[0].range.ge),
    day => day[0].range.ge
  );
}
